"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FeatureFlagProvider = void 0;
var _react = _interopRequireWildcard(require("react"));
var _cdsUtils = require("@cbhq/cds-utils");
var _FeatureFlagContext = require("./FeatureFlagContext");
var _useFeatureFlags2 = require("./useFeatureFlags");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function featureFlagReducer(state, action) {
  switch (action.type) {
    case 'update':
      {
        var _action$onChange;
        const newState = Object.assign({}, state, action.value);
        (_action$onChange = action.onChange) === null || _action$onChange === void 0 ? void 0 : _action$onChange.call(action, newState);
        return newState;
      }
    case 'toggle':
      {
        var _action$onChange2;
        const newState = Object.assign({}, state, {
          [action.name]: !state[action.name]
        });
        (_action$onChange2 = action.onChange) === null || _action$onChange2 === void 0 ? void 0 : _action$onChange2.call(action, newState);
        return newState;
      }
    default:
      {
        if ((0, _cdsUtils.isProduction)()) {
          return state;
        }
        throw new Error('useFeatureFlagUpdater requires `type` to be provided');
      }
  }
}
const FeatureFlagProvider = /*#__PURE__*/(0, _react.memo)(({
  children,
  flexGap: flexGapProp,
  fabric: fabricProp,
  onChange
}) => {
  const _useFeatureFlags = (0, _useFeatureFlags2.useFeatureFlags)(),
    flexGapContext = _useFeatureFlags.flexGap,
    fabricContext = _useFeatureFlags.fabric;
  const _useReducer = (0, _react.useReducer)(featureFlagReducer, _cdsUtils.emptyObject),
    featureFlagsState = _useReducer[0],
    dispatch = _useReducer[1];
  const contextValue = (0, _react.useMemo)(() => {
    return Object.assign({
      flexGap: flexGapProp !== null && flexGapProp !== void 0 ? flexGapProp : flexGapContext,
      fabric: fabricProp !== null && fabricProp !== void 0 ? fabricProp : fabricContext
    }, featureFlagsState);
  }, [fabricContext, fabricProp, featureFlagsState, flexGapContext, flexGapProp]);
  const dispatcherValue = (0, _react.useMemo)(() => ({
    onChange,
    dispatch
  }), [onChange]);
  return /*#__PURE__*/_react.default.createElement(_FeatureFlagContext.FeatureFlagDispatcherContext.Provider, {
    value: dispatcherValue
  }, /*#__PURE__*/_react.default.createElement(_FeatureFlagContext.FeatureFlagContext.Provider, {
    value: contextValue
  }, children));
});
exports.FeatureFlagProvider = FeatureFlagProvider;